import { render } from "./Block.vue?vue&type=template&id=5100dd82"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=5100dd82&lang=scss"

import exportComponent from "/Users/boris/Developer/me/git/retro-puzzle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__